module.exports = __webpack_public_path__ + "static/media/hat-chef.0b45edc7.svg";